import { render } from "./DashboardFooter.vue?vue&type=template&id=d920f5a4"
import script from "./DashboardFooter.vue?vue&type=script&lang=js"
export * from "./DashboardFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__